import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

const DeleteModal = ({show,handleClose,deleteDomain}) => {

return(

<Modal show={show} onHide={handleClose} centered>

<Modal.Body className="text-center">

<FiTrash2 size={50} color="red"/>

<h4 style={{marginTop:"10px"}}>Confirm Delete</h4>

<p>
You want to delete this domain.
This cannot be undone.
</p>

<div className="d-flex justify-content-center gap-3">

<Button variant="light" onClick={handleClose}>
Cancel
</Button>

<Button variant="danger" onClick={deleteDomain}>
Yes Delete
</Button>

</div>

</Modal.Body>

</Modal>

);

};

export default DeleteModal;